import RoutePaths from './RoutePaths';

type IdType = string | number;

export const getNewPath = (path: RoutePaths | string): string => {
  return `${path}/new`;
};

export const getViewPath = (path: RoutePaths | string, id: IdType): string => {
  return `${path}/${id}`;
};

export const getEditPath = (path: RoutePaths | string, id: IdType): string => {
  return `${path}/${id}/edit`;
};
